import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class InstitutionServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }
  public getAllDeptStaff(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceDept/getAllDeptStaff';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询所有数据接口
  public getAllData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceDept/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  /**
   * 获取当前用户的所在单位的顶级部门列表
   * @param opts
   */
  public getAllTopDeptData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceDept/top/list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceDept';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceDept';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deleteData(opts: string) {
    const url = serverUrl + '/api/spaceManage/spaceDept';
    return this.rSerivce.serverObj.delete(url, {
      params: { idList: opts },
    });
  }

  // 获取单个数据
  public getData(id: string) {
    const url = serverUrl + '/api/spaceManage/spaceDept/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 绑定区域
  public spaceBindArea(opts: object) {
    const url = serverUrl + '/api/spaceManage/space-dept-bind-area/bind';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 获取部门绑定区域Id列表
  public spaceBindAreaDept(id: string) {
    const url = serverUrl + '/api/spaceManage/space-dept-bind-area/dept/' + id;
    return this.rSerivce.serverObj.get(url);
  }
  // 获取单位列表
  public getCompanyList(opts: object) {
    const url = serverUrl + `/api/spaceManage/spaceStaff/getSubSpaceByAuth`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 获取本级及以下部门数据
  public getDeptAndSubDeptList(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceDept/get/deptAndSubDeptList';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
}
